import { styled } from '@mui/material/styles';

const BUTTON_SIZE = 20;

export const RadioIcon = styled('span')(
  ({
    theme: {
      palette: { background },
    },
  }) => ({
    borderRadius: '50%',
    width: BUTTON_SIZE,
    height: BUTTON_SIZE,
    boxShadow: 'inset 0 0 0 2px #D7D7D7, inset 0 -2px 0 #D7D7D7',
    '.Mui-focusVisible &': {
      outlineOffset: 2,
    },
    'input:disabled ~ &': {
      boxShadow: 'none',
      background: background.paper,
    },
    'input:hover ~ &': {
      background: '#D7D7D7',
      boxShadow: 'inset 0 0 0 #D7D7D7',
      border: 0,
      display: 'block',
      width: BUTTON_SIZE,
      height: BUTTON_SIZE,
      backgroundImage: `radial-gradient(${background.paper},${background.paper} 28%,transparent 32%)`,
      content: '""',
    },
  })
);

export const RadioCheckedIcon = styled(RadioIcon)(
  ({
    theme: {
      palette: { secondary, background },
    },
  }) => ({
    background: secondary.main,
    boxShadow: `inset 0 0 0 0 ${secondary.main}`,

    '&:before': {
      display: 'block',
      width: BUTTON_SIZE,
      height: BUTTON_SIZE,
      background: `radial-gradient(${background.paper}, ${background.paper} 28%,transparent 32%)`,
      content: '""',
    },
    'input:hover:enabled ~ &': {
      background: '#4F70DD',
      boxShadow: 'inset 0 0 0 #4F70DD',
    },
    'input:disabled ~ &': {
      background: background.paper,
    },
  })
);
